import {useGetTemplateQuery, useUpdateTemplateMutation} from "../../../../services/templates";
import {toast} from "react-toastify";
import {Box, CircularProgress, Divider, Typography} from "@mui/material";
import HtmlTemplateEditor from "./HtmlTemplateEditor";
import * as React from "react";
import {useParams} from "react-router-dom";
import {useEffect} from "react";

export default function EditTemplate() {
  const [updateTemplateApi] = useUpdateTemplateMutation();
  const {id} = useParams<{ id: string }>();

  const templateId = id ?? "";
  const skip = !templateId;
  const {data: activeTemplate, isLoading, isError, error} = useGetTemplateQuery(templateId);

  useEffect(() => {
    if (isError) {
      const msg =
        (error as any)?.data?.error ??
        (error as any)?.error ??
        "Failed to load template, please try again.";
      toast.error(msg);
    }
  }, [isError, error]);


  if (skip) {
    return <Typography color="error">No template id provided in the URL.</Typography>;
  }
  if (isLoading) {
    return (
      <Box sx={{py: 6, display: "flex", justifyContent: "center"}}>
        <CircularProgress/>
      </Box>
    );
  }
  if (isError) {
    toast.error("Failed to load template, please try again.");
    return (
      <Typography color="error">
        Can&apos;t load template {templateId}
      </Typography>
    );
  }

  const saveDesign = async (title: string, html: string, json: string, templateId: string | undefined) => {
    try {
      if (!templateId) {throw new Error("No template id provided.");}
      await updateTemplateApi({id: templateId, name: title.trim(), text: html, design:json}).unwrap();
      toast.success("Template updated successfully.");
    } catch (e) {
      toast.error("Failed to update template, please try again.");
    }
  }

  return (
    <>
      <Typography variant="h4" component="div" sx={{fontWeight: 600}}>
        <b>Edit template</b>
      </Typography>

      <Divider sx={{my: 2}}/>
      <HtmlTemplateEditor title={activeTemplate?.name} design={activeTemplate?.design} id={templateId} onSave={saveDesign}/>
    </>
  )
}